import React from "react";

const Home = () => {
  return (
    <>
      <div className="hero border-1 pb-3">
        <a
          href="https://www.trucktemposervice.com/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="card bg-dark text-white border-0 mx-3">
            <img
              className="card-img img-fluid"
              src="./assets/JMTransport.png"
              alt="Card"
              height={500}
            />
            <div className="card-img-overlay d-flex align-items-center">
              <div className="container">
                <h5 className="card-title fs-1 text fw-lighter">Advertise</h5>
                <p className="card-text fs-5 d-none d-sm-block ">
                  {/* Optional supporting text */}
                </p>
              </div>
            </div>
          </div>
        </a>
      </div>
    </>
  );
};

export default Home;